import React from "react";
import { useSelector } from "react-redux";
import { Table, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const MenuConfigurationTagsTable = ({ setOpenTagsEditModal, setRecord }) => {
  const { itemsTags } = useSelector((state) => state.menuConfigurationReducer);

  const columns = [
    {
      title: "Име Български",
      key: "bg",
      render: (record) => {
        const language = record?.languages.find(
          (lang) => lang.abbreviation === "bg"
        );

        return language ? language.value : "";
      },
    },
    {
      title: "Име Английски",
      key: "en",
      render: (record) => {
        const language = record?.languages.find(
          (lang) => lang.abbreviation === "en"
        );
        return language ? language.value : "";
      },
    },
    {
      title: "Име Румънски",
      key: "ro",
      render: (record) => {
        const language = record?.languages.find(
          (lang) => lang.abbreviation === "ro"
        );
        return language ? language.value : "";
      },
    },
    {
      title: "Име Руски",
      key: "ru",
      render: (record) => {
        const language = record?.languages.find(
          (lang) => lang.abbreviation === "ru"
        );
        return language ? language.value : "";
      },
    },
    {
      title: "Име Украйнски",
      key: "ua",
      render: (record) => {
        const language = record?.languages.find(
          (lang) => lang.abbreviation === "ua"
        );
        return language ? language.value : "";
      },
    },
    {
      title: "Снимка",
      key: "imagePath",
      dataIndex: "imagePath",
      render: (imagePath) =>
        imagePath !== "" && (
          <img
            className="menu-configuration-table-image"
            alt="icon"
            src={imagePath}
          ></img>
        ),
    },
  ];

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 10,
        }}
      >
        <Button
          icon={<PlusOutlined />}
          onClick={() => setOpenTagsEditModal(true)}
        >
          Добави Таг
        </Button>
      </div>
      <Table
        className="menu-configuration-tags-table"
        size="small"
        rowKey="tagId"
        columns={columns}
        dataSource={itemsTags}
        onRow={(record) => ({
          onClick: () => {
            setOpenTagsEditModal(true);
            setRecord(record);
          },
        })}
      />
    </>
  );
};

export default MenuConfigurationTagsTable;
